<template>
    <div>
        <div class="listbanner">
            <a href="javascript:;" title="联系我们">
                <img src="http://www.fulqun.com/images/pagebanner1.jpg" alt />
            </a>
        </div>
        <div class="listbox">
            <div class="list-show">
                <div class="title">
                    <em>
                        联系我们
                        <span></span>
                    </em>
                </div>
                <div class="show-lxwm">
                    <img src="http://www.fulqun.com/images/map.jpg" alt class="map" />
                    <div class="lxwminfo">
                        <li>
                            <img src="http://www.fulqun.com/images/tel.png" />联系电话：400-010-2266
                        </li>
                        <li>
                            <img src="http://www.fulqun.com/images/adress.png" />北京市丰台区南四环西路186号汉威国际广场二区9号楼6层03-07室
                        </li>
                        <li>
                            <img src="http://www.fulqun.com/images/xianlu.png" />乘坐地铁4号线至公益西桥站（B口出）下车 ，步行250米即到
                        </li>
                    </div>
                </div>
            </div>
        </div>
        <el-divider></el-divider>
        <div class="footer">
            <ul class="putbox">
                <li>芙清fulqun官网</li>
                <li>Beijing FulQun Bio-Technology Co. Ltd</li>
                <li>北京芙清生物科技有限公司©</li>
                <li>地址：北京市丰台区南四环西路186号汉威国际广场二区9号楼6层03-07室</li>
                <li>
                    <a href="https://beian.miit.gov.cn/">京ICP备19037671号-1</a>
                </li>
                <li @click="() => { this.$router.push('/img') }">
                    互联网药品信息服务资格证书
                </li>
            </ul>
            <div class="contactbox">
                <p>400-010-2266</p>
                <p>周一至周五 9:00-17:30</p>
                <p>在线客服</p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {};
    },
    methods: {
        go() {
            this.$router.push('/certification')
        }
    },
};
</script>

<style lang="less" scoped>
.listbanner {
    width: 100%;
    overflow: hidden;
}

.listbanner img {
    width: 100%;
    height: auto;
    display: block;
}

.listbox {
    width: 100%;
    margin: 2rem 0;
}

.list-show {
    width: 80%;
    margin: 0 auto;
    max-width: 1000px;
}

.list-show .title {
    text-align: center;
    color: #1e456f;
    position: relative;
}

.list-show .title em {
    font-size: 16px;
    font-weight: 500;
    position: relative;
    border-bottom: solid 5px #e13837;
    padding-bottom: 0.5rem;
}

.show-lxwm {
    width: 60%;
    margin: 2rem auto;
}

.show-lxwm img {
    width: 100%;
    display: block;
}

.lxwminfo {
    overflow: hidden;
    margin-top: 1rem;
}

.lxwminfo li {
    line-height: 30px;
    color: #434343;
}

.lxwminfo li img {
    width: auto;
    height: 20px;
    float: left;
    margin-right: 6px;
    margin-top: 5px;
}

.title {
    color: #666;
    font-weight: bold;
}

.footer {
    height: 200px;
    padding: 30px;
    background-color: rgb(250, 250, 250);
    display: flex;
    justify-content: space-between;
}

.putbox {
    list-style: none;
    font-size: 12px;
    width: 70%;
    margin-top: 10px;
    padding-left: 10%;
    line-height: 30px;
}

.putbox a {
    text-decoration: none;
    color: #666;
}

.contactbox {
    width: 30%;
    height: 100%;
    text-align: center;
    line-height: 50px;
}

.contactbox p:nth-child(1) {
    color: rgb(65, 110, 179);
    font-size: 28px;
}

.contactbox p:nth-child(2) {
    font-size: 14px;
    color: #666;
}

.contactbox p:nth-child(3) {
    width: 180px;
    height: 36px;
    margin: auto;
    border: 1px solid rgb(65, 110, 179);
    color: rgb(65, 110, 179);
    line-height: 36px;
    cursor: pointer;
}
</style>
